import React, { useEffect, useState } from "react";
import Reporter from "../component/reporter";
import "../Main.css";
import { HOST_URL } from "../common";

const ReportScreen = (location) => {
  const [todayIssue, setTodayIssue] = useState([]);
  const [nextdayIssue, setNextdayIssue] = useState([]);
  const [etcIssue, setEtcIssue] = useState([]);

  const [isFinalReported, setIsFinalReported] = useState(false);
  const [userName, setUserName] = useState("");

  const [reportDate, setReportDate] = useState("");

  const fetchReport = (date) => {
    //const url = 'http://30.30.30.3:3002/report?&cmd=read&date=' + date
    const url = HOST_URL + ":3002/report?&cmd=read&date=" + date;
    fetch(url, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.code === "error" && result.reason === "session error") {
          window.location.href = "/";
        }

        setUserName(result.userName);

        if (result.report.todayissue !== undefined) {
          setTodayIssue(result.report.todayissue);
        }

        if (result.report.nextdayissue !== undefined) {
          setNextdayIssue(result.report.nextdayissue);
        }

        if (result.report.etcissue !== undefined) {
          setEtcIssue(result.report.etcissue);
        }

        if (result.report.finalReport === "true") {
          setIsFinalReported(true);
        }
      });
  };

  useEffect(() => {
    let href = window.location.href;
    const date = href.substr(href.indexOf("date") + 5, href.length);

    setReportDate(date);
    fetchReport(date);
  }, []);

  return (
    <div>
      <Reporter
        date={reportDate}
        name={userName}
        readOnly={isFinalReported}
        today={todayIssue}
        nextday={nextdayIssue}
        etc={etcIssue}
      />
    </div>
  );
};

export default ReportScreen;
